import { render, staticRenderFns } from "./PatientPanelActions.vue?vue&type=template&id=ef7372de&scoped=true"
import script from "./PatientPanelActions.vue?vue&type=script&lang=js"
export * from "./PatientPanelActions.vue?vue&type=script&lang=js"
import style0 from "./PatientPanelActions.vue?vue&type=style&index=0&id=ef7372de&prod&lang=scss&scoped=true"
import style1 from "./PatientPanelActions.vue?vue&type=style&index=1&id=ef7372de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef7372de",
  null
  
)

export default component.exports